import React from "react";

// @material-ui/core components

// core components
import GridContainer from "@components/Grid/GridContainer.js";
import GridItem from "@components/Grid/GridItem.js";

import { Formik, FormikProps } from "formik";
import CardWrapper from "@components/Card/CardWrapper";
import { codeGeneratorFields } from "../constants";
import { createCodeGeneratorFieldsValidationSchema } from "apps/things/app/validations";
import CodeGeneratorForm from "./CodeGeneratorForm";
import { InitializeCodeGenInput } from "apps/things/app/types/thingsGlobalTypes";

interface IRTable {
  title?: string;
  TableAction?: React.ReactNode;
  bulkDeleteProducts?: () => void;
  handleResetCode: () => void;
  handleDaysCode: (days: number) => void;
  handleFreeCode: () => void;
  oemItemID?: string;
  itemId?: string;
  handleCreateCodeEvent: (payload: any) => void;
  handleCreateOrUpdateAvatar: (
    remDays: string,
    payGoState: string,
    deviceState: string,
    decHashTop: string,
    daysPassed: string
  ) => void;
  isLoading: boolean;
}

const AddCodeGenerator: React.FC<IRTable> = ({
  isLoading,
  handleCreateCodeEvent,
  itemId,
  ...rest
}) => {
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <CardWrapper>
          <Formik
            onSubmit={async (values: any) => {}}
            initialValues={{
              [codeGeneratorFields.codeSystemId]: "",
              [codeGeneratorFields.hashRoot]: "",
              [codeGeneratorFields.hashTop]: "",
              [codeGeneratorFields.hashIndex]: 100000,
              [codeGeneratorFields.codeReversalCount]: 0,
              [codeGeneratorFields.codeGenId]: "",
              [codeGeneratorFields.codeCount]: 0,
              [codeGeneratorFields.itemId]: itemId,
              [codeGeneratorFields.oemItemID]: "",
            }}
            validationSchema={createCodeGeneratorFieldsValidationSchema}
            validateOnChange={true}
          >
            {(formBag) => (
              <CodeGeneratorForm
                formBag={
                  formBag as unknown as FormikProps<InitializeCodeGenInput>
                }
                loading={isLoading}
                handleCreateCodeEvent={handleCreateCodeEvent}
                {...rest}
              />
            )}
          </Formik>
        </CardWrapper>
      </GridItem>
    </GridContainer>
  );
};

export default AddCodeGenerator;
